import classNames from 'classnames';
import { type FC, useState } from 'react';
import Translation from '../../../general/Translation/Translation';
import { useTypedSelector } from '../../Store/connectors';
import Button from '../../../../stories/Atoms/Button/Button';
import styles from './IssuuPreview.module.scss';
import Dialog from '../../../../stories/Molecules/Dialog/Dialog';
import { useWithSiteUrl } from '../../../general/WebshopContext/WebshopContext';

const IssuuPreview: FC = () => {
  const issuuId = useTypedSelector(({ gallery }) => gallery.issuuId);
  const withSiteUrl = useWithSiteUrl();
  const [dialogState, setDialogState] = useState({
    isLoading: false,
    isOpen: false,
  });

  if (!issuuId) {
    return null;
  }

  const toggleDialog = (show: boolean) => {
    setDialogState({
      isLoading: show,
      isOpen: show,
    });
  };

  return (
    <>
      <Button
        onClick={() => toggleDialog(true)}
        className={classNames(styles.IssuuPreview__button)}
        white
      >
        <Translation
          pageString="productinformatie"
          stringId="voorbeeld"
        />
      </Button>
      <Dialog
        size="lg"
        onClose={() => toggleDialog(false)}
        open={dialogState.isOpen}
        isLoading={dialogState.isLoading}
        closeButton
      >
        <Dialog.Body>
          <iframe
            data-testid="issuu-iframe"
            className={styles.IssuuPreview__dialog__iframe}
            src={withSiteUrl(`product-page/issuu?issuuId=${issuuId}`)}
            onLoad={() =>
              setDialogState((state) => ({ ...state, isLoading: false }))
            }
          />
        </Dialog.Body>
      </Dialog>
    </>
  );
};

export default IssuuPreview;
